module.exports = __webpack_public_path__ + "img/1.74f6224f.webp";